module.exports = __webpack_public_path__ + "img/sec_in_device1.a5cee6fc.png";